import * as React from 'react';
import { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { Box, Slide}  from '@material-ui/core';

import GetAppIcon from '@material-ui/icons/GetApp';

import sampleData from 'src/utils/sampleData.json';
import PaymentCard from 'src/materials/PaymentCard';

import helper from 'src/utils/helpers';

//Redux
import { useSelector, useDispatch } from "react-redux";



const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog({type}) {
  const classes = useStyles();
  const { user } = useSelector(state => state.auth);

  const [open, setOpen] = React.useState(false);
  const [selected, setSelect] = useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



  return (
    <div className="flex-grow-1 center-element" >
     {type === 'pay' ? <Button size="small" className="flex-grow-1"
      onClick={handleClickOpen}
        >ADD PAYMENT</Button>
             : type === 'cashout' && <Button size="small" 
             onClick={handleClickOpen}
        >Cash Out &nbsp;&nbsp; <GetAppIcon/></Button>} 
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar} >
          <Toolbar variant="dense">
          
            <Typography
                        //  sx={{ flexGrow: 1 }}

             variant="h6"
             className="text-left"
            >{type === 'pay' ? 'Payment Request' : 'Cash Out' }</Typography>
              <Typography
             sx={{ flexGrow: 1 }}
             variant="h6"
            ></Typography>

<IconButton
            size="small"
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Toolbar>
        </AppBar>
        <br/>
        <Box
        sx={{
          // flexDirection: 'column',
          height: '100%',
          maxWidth: '400px',
          margin: 'auto',
          pt: 5
        }}
      >
          {type !== 'pay' && <>         <Typography className="text-center" variant="h6">CASH AVAILABLE</Typography>
                <Typography className="text-center" color="primary" variant="h5">{helper.toCurrency(user && user.current ? user.current : 0)}</Typography></>}

      
        <br/>
        {sampleData.payments.map((a, index) => {
          return <PaymentCard key={index} index={index} setClick={(e) => setSelect(e !== selected ? e : null)} data={a} open={index === selected} type={type} handleClose={handleClose}/>
        })}
                <br/>

             <Typography className="text-center text-danger">NOTICE</Typography>
        <Typography className="text-center" variant="body2">We are still improving our system, cash-out request may take up to 1 working day to be transferred to your receiver.</Typography>
        <Typography className="text-center" variant="body2">Thank you for bearing with us!</Typography> 
      </Box>
       
      </Dialog>
    </div>
  );
}
